import { apiRequest } from './client';

/** Support tickets (SRS #17/#18): lifecycle, replies, history. */

const BASE = '/api/v1/support';
const TOKEN_KEY = 'policyora_token';

function opts(extra: RequestInit = {}): RequestInit {
  const token = localStorage.getItem(TOKEN_KEY);
  return { ...extra, headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(extra.headers || {}) } };
}

export type Lifecycle = 'open' | 'in_progress' | 'waiting_on_customer' | 'resolved' | 'closed';
export type Priority = 'low' | 'normal' | 'high' | 'urgent';

export interface TicketEvent {
  id: number;
  kind: 'created' | 'customer_reply' | 'admin_reply' | 'status' | 'assign' | 'priority';
  actor_type: 'user' | 'admin' | 'system';
  actor_email: string | null;
  body: string | null;
  created_at: string;
}

export interface Ticket {
  id: number;
  subject: string;
  message: string;
  user_email: string | null;
  user_name: string | null;
  user_organization: string | null;
  lifecycle: Lifecycle;
  priority: Priority;
  assigned_to: string | null;
  assigned_at: string | null;
  attachment_name: string | null;
  created_at: string;
  updated_at: string | null;
  resolved_at: string | null;
  closed_at: string | null;
  read_state: string;
  history?: TicketEvent[];
}

export const LIFECYCLE_LABEL: Record<Lifecycle, string> = {
  open: 'Open',
  in_progress: 'In progress',
  waiting_on_customer: 'Waiting on you',
  resolved: 'Resolved',
  closed: 'Closed',
};

export const listMyTickets = () => apiRequest<{ tickets: Ticket[] }>(`${BASE}/tickets`, opts());
export const getMyTicket = (id: number) => apiRequest<Ticket>(`${BASE}/tickets/${id}`, opts());
export const replyToMyTicket = (id: number, body: string) =>
  apiRequest<Ticket>(`${BASE}/tickets/${id}/reply`, opts({ method: 'POST', body: JSON.stringify({ body }) }));
export const closeMyTicket = (id: number) => apiRequest<Ticket>(`${BASE}/tickets/${id}/close`, opts({ method: 'POST' }));

export const adminListTickets = (params: { lifecycle?: string; priority?: string; assigned?: string; limit?: number; offset?: number }) => {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') sp.append(k, String(v)); });
  const qs = sp.toString();
  return apiRequest<{ tickets: Ticket[]; total: number; counts: Record<Lifecycle, number> }>(`${BASE}/admin/tickets${qs ? `?${qs}` : ''}`, opts());
};
export const adminGetTicket = (id: number) => apiRequest<Ticket>(`${BASE}/admin/tickets/${id}`, opts());
export const adminReply = (id: number, body: string) =>
  apiRequest<Ticket>(`${BASE}/admin/tickets/${id}/reply`, opts({ method: 'POST', body: JSON.stringify({ body }) }));
export const adminUpdate = (id: number, body: { lifecycle?: Lifecycle; priority?: Priority; assign_to?: string }) =>
  apiRequest<Ticket>(`${BASE}/admin/tickets/${id}`, opts({ method: 'PATCH', body: JSON.stringify(body) }));
